import React from "react";
import styled from "@emotion/styled";

const PasswordSuggest = () => {
  return (
    <Container>
      <Text>คำแนะนำการตั้งรหัสผ่าน</Text>
      <ul>
        <Rule>ต้องมีความยาวไม่น้อยกว่า 8 ตัวอักษร</Rule>
        <Rule>ประกอบด้วยตัวเลข (0-9) หรือตัวอักษรภาษาอังกฤษ(a-z)</Rule>
        <Rule>โปรดตั้งรหัสผ่านที่จดจำได้ง่าย</Rule>
      </ul>
    </Container>
  );
};

export default PasswordSuggest;

const Container = styled.div`
  background: #323a46;
  border-radius: 8px;
  font-family: Noto Sans Thai, Noto Sans;
  color: #fcfcfc;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  padding: 10px;
  width: 308px;
  margin: auto;
`;
const Text = styled.div``;
const Rule = styled.li``;
